
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.333 4c0-.369.299-.667.667-.667h12a.667.667 0 110 1.333H2a.667.667 0 01-.667-.667z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.667 2A.667.667 0 006 2.665v.667h4v-.667a.667.667 0 00-.667-.667H6.667zm4.666 1.333v-.667a2 2 0 00-2-2H6.667a2 2 0 00-2 2v.667H3.333a.667.667 0 00-.666.666v9.334a2 2 0 002 2h6.666a2 2 0 002-2V3.999a.667.667 0 00-.666-.666h-1.334zM4 4.666v8.667a.667.667 0 00.667.666h6.666a.667.667 0 00.667-.666V4.666H4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.667 6.666c.368 0 .666.298.666.667v4a.667.667 0 11-1.333 0v-4c0-.369.299-.667.667-.667zM9.333 6.666c.369 0 .667.298.667.667v4a.667.667 0 11-1.333 0v-4c0-.369.298-.667.666-.667z"}})])
          )
        }
      }
    